define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"dojo/store/Memory",
	"csi/_base/underscore",
	"csi/action/EmailController",
	"csi/comm",
	"csi/comm/PostRequest",
	"csi/locale",
	"csi/widget/MessageDialog",
	"csi/xml",
	"csi/xml/Search"
], function(declare, lang, Memory, _, EmailController, comm, PostRequest, locale, MessageDialog, xml, Search) {

	return declare(EmailController, {
		/**
		 * @override
		 * Add dependency path to the Data Packages of Line Items (needed for _validate and in _createStoreItemFromLineItem)
		 */
		onPreActionDeferreds: function(dfds) {
			dfds.push(this.getCache().getNodeDependencies(this.getNodeURL(), ["Child:SRLineItems/Child:SRLineItemPackage"]));
		},

		preProcess: function() {
			var self = this;

			this.when(this.validate(), function() {
				EmailController.prototype.preProcess.call(self);
			});
		},

		/**
		 * Show error if no line items
		 */
		onValidate() {
			if (!this._getLineItems().length) {
				throw new Error(this.getError());
			}
		},

		getUsersStoreOptions: function() {
			// summary: pull all Contacts from Supplier into the list of available email addresses
			var options = this.inherited(arguments);

			var search = new Search({Module: EmailController.USERS_STORES_MODULE, Operation: EmailController.USERS_STORES_OPERATION});
			search.setLimitPath(this.m_urlNode);
			search.setLimitPath(this.m_urlNode, xml.path("Contacts"));
			var q = search.getQuery();
			q.Attr("Email", xml.OP_NOT_EQUALS, "");

			options.request = search.getRequest();

			return options;
		},

		getAttachmentsStore: function() {
			// summary: returns the attachments' store
			var data = _.map(this._getLineItems(), lang.hitch(this, this._createStoreItemFromLineItem));
			data = _.filter(data, function(item) {return item;});
			this._attachmentsStoreData = data;
			return new Memory({
				idProperty: "$",
				nameProperty: "Name",
				labelProperty: "Name",
				data: data
			});
		},

		getInitialValues: function() {
			// summary: get initial values for Email form
			var initialValues = this.inherited(arguments);

			initialValues.attachments = _.map(this._attachmentsStoreData, function(item) {return item.$;});

			return initialValues;
		},

		onValidateValues: function(values) {
			var request = new PostRequest("Sourcing", "SupplierRequestCheckZipSizes");
			request.addParameter(xml.PROP_URL, this.m_urlParent);
			request.addParameter("LineItems", values.attachments);
			request.go().then(lang.hitch(this, this._onCheckZipSizesResponse, values));
		},

		_onCheckZipSizesResponse: function(/*Object*/values, /*Response*/response) {
			var resultNodes = response.getResultNodes();
			if (!resultNodes || !resultNodes.length) {
				this._sendEmailWithoutValidation();
			} else {
				var lineItemNames = _.reduce(resultNodes, function(result, node) {
					var name = node.$Name;
					if (result)
						result += ", " + name;
					else
						result = name;
					return result;
				}, null);

				this.confirmAction({
					message: locale.resource("SupplierRequestCheckZipSizes_Confirm", [lineItemNames]),
					buttons: ["REMOVE_AND_SEND" + MessageDialog.BUTTON_PRIMARY, MessageDialog.BUTTON_CANCEL],
					onResponse: lang.hitch(this, this._onConfirmRemovingBigSizesResponse, values, resultNodes)
				});
			}
		},

		_onConfirmRemovingBigSizesResponse: function(/*Object*/values, /*Node[]*/lineItemsWithBigAttachments, /*String*/buttonKey) {
			if (buttonKey == "REMOVE_AND_SEND") {
				var urlsToRemove = _.map(lineItemsWithBigAttachments, function(node) {return node.$URL;});

				values.attachments = _.difference(values.attachments, urlsToRemove);

				this.dialog.set("value", {attachments: values.attachments});

				this._sendEmailWithoutValidation();
			} else {
				this.postProcess();
			}

		},

		_sendEmailWithoutValidation: function() {
			this.resumeProcess();
			this.process();
		},

		toWriter: function() {
			// summary: set values to email message
			var call = this.inherited(arguments);

			call.setModuleOperation("Sourcing", "SupplierRequestEmailDataPackages");
			call.addParameter(xml.PROP_URL, xml.ATTR_REF, this.m_urlParent);
			call.addParameter("LineItems", xml.ATTR_REFLIST, this._values.attachments);

			return call;
		},

		_createStoreItemFromLineItem: function(lineItem) {
			if (!lineItem)
				return null;

			var dataPackage = this.getCache().getNode(lineItem.SRLineItemPackage);
			if (!dataPackage)
				return null;

			var name = dataPackage.$Name + ".zip";
			return {$: lineItem.$URL, Name: name};
		},

		_getLineItems: function() {
			var cache = this.getCache();

			var supplierRequest = this.getParent();
			var lineItems = cache.getNodes(supplierRequest.LineItems);

			lineItems = _.filter(lineItems, function(lineItem) {
				return lineItem && xml.isValidURL(lineItem.PDF) && xml.isValidURL(lineItem.SRLineItemPackage) && xml.nodeHasAccess(cache.getNode(lineItem.SRLineItemPackage), xml.RIGHT_READ);
			});

			return lineItems;
		}
	});
});